type BreadcrumbProps = {
  image?: string;
  title?: string;
  link?: string;
};

function Breadcrumb(props: BreadcrumbProps) {
  return (
    <div
      className={`ltn__breadcrumb-area text-left bg-overlay-white-30 ${props.image}`}
    >
      <div className="container pt-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__breadcrumb-inner">
              <h1 className="page-title top-a overlay2 overlay_1">
                {props.title}
              </h1>
              <div className="ltn__breadcrumb-list"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Breadcrumb;
